import { useRoutes } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import { routes } from "./routes";
import {useEffect} from "react";
import {fetchToken} from "../store/auth-slice";

// Check if the user has the required permissions for a route
const hasRequiredPermissions = (requiredPermissions, userRole) => {
    if (!requiredPermissions) return true; // No permissions required for the route
    return requiredPermissions.includes(userRole); // Check if the user's role is allowed
};

// Recursively filter routes based on user roles
const filterRoutesByRoles = (routeConfig, userRole) =>
    routeConfig
        .filter((route) => hasRequiredPermissions(route.permissions, userRole))
        .map((route) => ({
            ...route,
            children: route.children
                ? filterRoutesByRoles(route.children, userRole)
                : undefined,
        }));

// Main component to render routes based on user roles
const RenderRoutes = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchToken());
    });

    const { selectedRole } = useSelector((state) => state.auth);
    // Determine user role
    let userRole;
    if(selectedRole){
        userRole = `${selectedRole.scope}${selectedRole.role}`;
    }
    else {
        userRole = "Customer"
    }
    // Filter routes based on user role
    const accessibleRoutes = filterRoutesByRoles(routes, userRole);
    // Render the accessible routes

    return useRoutes(accessibleRoutes);
};

export default RenderRoutes;
